var hasAssign = typeof Object.assign === "function";
export var assign = function (target) {
    var sources = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        sources[_i - 1] = arguments[_i];
    }
    for (var _a = 0, sources_1 = sources; _a < sources_1.length; _a++) {
        var source = sources_1[_a];
        if (hasAssign) {
            Object.assign(target, source);
        }
        else {
            for (var property in source) {
                if (Object.prototype.hasOwnProperty.call(source, property)) {
                    target[property] = source[property];
                }
            }
        }
    }
    return target;
};
export var isMap = function (target) {
    return (typeof target === "object" &&
        typeof target !== "function" &&
        !Array.isArray(target) &&
        target !== null);
};
